import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../locales/en.json';
import id from '../locales/id.json';
import vi from '../locales/vi.json';

const resources = {
  en: { translation: en },
  id: { translation: id },
  vi: { translation: vi },
};

i18n
  // pass the i18n instance to react-i18next.
  .use(LanguageDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    compatibilityJSON: 'v4',
    resources,
    lng: 'hi', // default language
    fallbackLng: 'en',
    detection: {
      convertDetectedLanguage: (lng: string) =>
      lng.replace(/_.*|-.*/, '').replace('vn', 'vi'),
    }
  } as any);

export default { i18n };